(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Linkedin', Linkedin);

    Linkedin.$inject = ['$resource'];

    function Linkedin ($resource) {
        return $resource('api/import/profiles/linkedin', {}, {
            importContacts: {
                method: "POST",
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        });
    }
})();
